export default __webpack_public_path__ + "static/media/arpit.69037cff.png";